import React from "react"
import { Button } from "@mui/material"
import { withTheme } from "@emotion/react"



function BtnPrimary(props) {
    const theme = props.theme

    return (

        <Button sx={{ width: props.width, height: props.height,
            ...theme.button.primary, gap:'8px',...theme.typography.button,
            padding: ((props.arrowLeft && theme.button.padding.p1211) || (props.arrowRight && theme.button.padding.p1112) ) ?? theme.button.padding.p1624,
            boxShadow:'none',
            }} 
            variant="contained" 
            onClick={props.onClick}
            >

            {props.arrowLeft &&
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.37999 12.5467C6.25332 12.5467 6.12666 12.5 6.02666 12.4L1.97999 8.35333C1.78666 8.16 1.78666 7.84 1.97999 7.64667L6.02666 3.6C6.21999 3.40667 6.53999 3.40667 6.73332 3.6C6.92666 3.79333 6.92666 4.11333 6.73332 4.30667L3.03999 8L6.73332 11.6933C6.92666 11.8867 6.92666 12.2067 6.73332 12.4C6.63999 12.5 6.50666 12.5467 6.37999 12.5467Z" fill="white" />
                    <path d="M13.6667 8.5H2.44666C2.17332 8.5 1.94666 8.27333 1.94666 8C1.94666 7.72667 2.17332 7.5 2.44666 7.5H13.6667C13.94 7.5 14.1667 7.72667 14.1667 8C14.1667 8.27333 13.94 8.5 13.6667 8.5Z" fill="white" />
                </svg>
            }
            {props.text}
            {
                props.arrowRight && <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.62 12.5467C9.49333 12.5467 9.36667 12.5 9.26667 12.4C9.07333 12.2067 9.07333 11.8867 9.26667 11.6933L12.96 8L9.26667 4.30667C9.07333 4.11333 9.07333 3.79333 9.26667 3.6C9.46 3.40667 9.78 3.40667 9.97333 3.6L14.02 7.64667C14.2133 7.84 14.2133 8.16 14.02 8.35333L9.97333 12.4C9.87333 12.5 9.74667 12.5467 9.62 12.5467Z" fill="white" />
                    <path d="M13.5533 8.5H2.33333C2.06 8.5 1.83333 8.27333 1.83333 8C1.83333 7.72667 2.06 7.5 2.33333 7.5H13.5533C13.8267 7.5 14.0533 7.72667 14.0533 8C14.0533 8.27333 13.8267 8.5 13.5533 8.5Z" fill="white" />
                </svg>
            }
        </Button>

    )
}

export default withTheme(BtnPrimary)